/* Debug flag — lets you check script presence in console */
window.__swatchDebug = 'loaded';

/* Single delegated click listener */
document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.swatch');
  if (!swatch) return;

  /* Run only on our collection-grid dots */
  const row = swatch.closest('.card-swatches');
  if (!row) return;      // product-page picker → leave Dawn alone

  /* Stop the product-card link */
  e.preventDefault();
  e.stopPropagation();

  const card = swatch.closest('.card-wrapper');
  const img  = card?.querySelector('[data-main-image]');
  const src  = swatch.dataset.image;
  if (!img || !src || img.src.includes(src)) return;

  /* Highlight active colour */
  card.querySelectorAll('.swatch')
      .forEach(btn => btn.classList.toggle('is-active', btn === swatch));

  /* INSTANT swap — no fade, no grey flash */
  img.src    = src;
  img.srcset = `${src} 533w`;
});
